import React from "react";
import PropTypes from "prop-types";

export const getTextWithFirstLineLikeAHeader = text => {
  const [header, ...rest] = text;
  const result = [<p key={header}>{header}</p>, ...rest];

  return result;
};

export const processNewLines = ({
  title: text,
  isFirstLineTheHeader = false
}) => {
  if (isFirstLineTheHeader && Array.isArray(text)) {
    return getTextWithFirstLineLikeAHeader(text);
  }

  if (typeof text !== "string") {
    return text;
  }

  const textParts = text.trim().split("\n");
  const result = textParts
    .slice(0, -1)
    .reduce(
      (resultItem, textPart) => [
        ...resultItem,
        textPart,
        <br key={textPart} />
      ],
      []
    )
    .concat(textParts.slice(-1));

  if (isFirstLineTheHeader) {
    result[0] = <p>{result[0]}</p>;
  }

  return <>{result}</>;
};

processNewLines.propTypes = {
  title: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  isFirstLineTheHeader: PropTypes.bool
};
